import { render, staticRenderFns } from "./HomeworkList.vue?vue&type=template&id=18efbafd&scoped=true&lang=pug&"
import script from "./HomeworkList.vue?vue&type=script&lang=ts&"
export * from "./HomeworkList.vue?vue&type=script&lang=ts&"
import style0 from "./HomeworkList.vue?vue&type=style&index=0&id=18efbafd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18efbafd",
  null
  
)

export default component.exports